import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { forkJoin } from 'rxjs';
import { RoleType } from 'src/app/enum/role-type';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { ReportService } from 'src/app/services/report.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-customer-risk-report',
    templateUrl: './customer-risk-report.component.html',
    styleUrls: ['./customer-risk-report.component.scss']
})
export class CustomerRiskReportComponent implements OnInit {

    customerRiskReportForm: FormGroup;
    toMinDate: Date;
    toMaxDate=new Date()
    @ViewChild('startDate') startDateDatePicker: MatDatepicker<Date>;
    @ViewChild('endDate') endDateDatePicker: MatDatepicker<Date>;
    enquiryStatusList: any = []
    filteredList1: any = []
    LoginRoleId: any;
    sessionDataString: any;
    userListUnEncryptedCustReport: string[];
    serviceQueue: any = []
    applicationStatusTypeList: any;
    constructor(
        private fb: FormBuilder,
        private reportService: ReportService,
        private sessionService: UserSessionService,
        private lookupDataService: LookupDataServiceService
    ) {
        this.sessionDataString = JSON.parse(localStorage.getItem(
            this.sessionService.localStorageSessionKey));
    }


    ngOnInit(): void {
        this.init()
        if (this.sessionDataString.roletype == RoleType.Admin || this.sessionDataString.roletype == RoleType.SuperAdmin || this.sessionDataString.roletype == RoleType.Staff) {
            this.loadServiceQueue();
            this.executeServiceQueue();
        }
    }
    init() {
        this.customerRiskReportForm = this.fb.group({
            startDate: [null, Validators.required],
            endDate: [null, Validators.required],
            enquiryStatus: [null,],
        });
    }
    Reset() {
        this.customerRiskReportForm.reset()
    }
    openStartDateDatePicker() {
        this.startDateDatePicker.open();
    }

    openEndDateDatePicker() {
        this.endDateDatePicker.open();
        this.toMinDate = this.customerRiskReportForm.controls["startDate"].value;
        // this.toMaxDate = this.addMonths(this.toMinDate, 3);
    }
    loadServiceQueue() {
        this.serviceQueue.push(this.lookupDataService.getCompuscanEnquiryRiskType());
    }
    executeServiceQueue() {
        forkJoin(this.serviceQueue).subscribe((serviceResponse) => {
            this.enquiryStatusList = serviceResponse[0];
            this.enquiryStatusList = this.enquiryStatusList.sort((a, b) => a.value.localeCompare(b.value));
            this.filteredList1 = this.enquiryStatusList.slice()
        });
    }

    generateExcel  () {
        if (!this.customerRiskReportForm.value.startDate && !this.customerRiskReportForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date and To date should not be empty',
                position: 'center',

            })
        }
        else if (!this.customerRiskReportForm.value.startDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date should not be empty',
                position: 'center',

            })
        }
        else if (!this.customerRiskReportForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'End date should not be empty',
                position: 'center',

            })
        }
        else if (this.customerRiskReportForm.value.startDate > this.customerRiskReportForm.value.endDate) {
         if (this.customerRiskReportForm.value.endDate) {

                Swal.fire({
                    icon: 'warning',
                    title: 'End Date should be greater than Start Date',
                    position: 'center',

                })
            }
        }
        else {
            this.reportService.getCustomerRiskReport(this.customerRiskReportForm.value).subscribe( (data)=> {
                if (data) {
                    const linkSource = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64, ' + data;
                    const downloadLink = document.createElement('a');
                    const fileName = 'CustomerRiskReport.xls';
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                }
            });
        }


    }
}
